module.exports = __webpack_public_path__ + "static/locks_meme-108b1ea342c79a8a5678842d98dde6a0.jpg";